<template>
  <div>abc</div>
</template>

<script>
export default {
  name: "CheckoutDetail",
  created() {
    const { params } = this.$route;
    console.log(params.id);
  },
};
</script>

<style></style>
